import React, { useState, useEffect, KeyboardEvent, useRef, useMemo } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Autocomplete, Box } from '@mui/material';

export interface Item {
    [key: string]: any;  // This allows any key with any type of value
}

export interface SearchDropdownProps {
    searchData: Item[];
    searchFields: string[]; // Fields to search within each item
    onChange: (name: string) => void;
    className?: string;
}

const FSearchDropdown: React.FC<SearchDropdownProps> = ({ searchData, className, onChange }) => {
    const handleOptionChange = (option: Item) => {
        onChange(option.name); // Call onChange when the option is selected
        return option.name; // Return the label to display in Autocomplete
    };
    return (
        <div className={className}>
            <Autocomplete
                className='w-full'
                id="country-select-demo"
                options={searchData}
                autoHighlight
                getOptionLabel={(option) => option.name + ` (\$${option.price / 100})`}
                onChange={
                    (event, value) => {
                        if (value) {
                            handleOptionChange(value);
                        }
                    }
                }
                
                renderOption={(props, option) => {
                    const priceInDollar = Number(option.price) / 100;
                    return (
                        <Box component="li" {...props} key={option.name}>
                            {option.name} (${priceInDollar}) {option.description}
                        </Box>
                    )
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Product"
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                    />
                )}
            />
        </div>
    );
};

export default FSearchDropdown;
